/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { newAppStoryMediaSchema } from "./newAppStoryMediaSchema.ts";
import { newAppStoryProductSchema } from "./newAppStoryProductSchema.ts";

export const newAppStorySchema = z
	.object({
		order: z.int(),
		text: z.string(),
		tag: z.string(),
		products: z.array(newAppStoryProductSchema),
		media_url: newAppStoryMediaSchema.describe("Медиа истории."),
	})
	.describe("История приложения и QR-меню.");
